import type { FixedProductInput } from '@vy/types';
import React, { useMemo } from 'react';
import { ChargesEditDataGrid } from '../ChargesEditDataGrid';
import { getFixedChargesEditColumns } from './fixed-charges-edit-table-utils';

type FixedChargesEditTableProps = {
  fixedProducts: FixedProductInput[];
  isInvoice?: boolean;
  isParentAgreement?: boolean;
};

export const FixedChargesEditTable: React.FC<FixedChargesEditTableProps> = ({
  fixedProducts,
  isInvoice = false,
  isParentAgreement = false,
}) => {
  const columns = useMemo(
    () => getFixedChargesEditColumns(fixedProducts, isInvoice, isParentAgreement),
    [fixedProducts, isInvoice, isParentAgreement],
  );

  return (
    <ChargesEditDataGrid
      columns={columns}
      rows={fixedProducts}
      columnHeaderHeight={36}
      rowHeight={56}
      disableColumnMenu
      disableRowSelectionOnClick
      hideFooter
    />
  );
};
